import * as actionTypes from '../actionTypes';
const initialState = {
    success:false,
    loading:false,
    loading_confirmation:false,
    aimags:[],
    aimagWater:[],
    requests:[],
    definitions:[],
};
export default  (state = initialState,action)=>{
    switch (action.type) {
        case actionTypes.getAimagWater.REQUEST:
            return {
                ...state,
                loading: true,
                aimagWater: [],
            }
        case actionTypes.getAimagWater.RESPONSE:
            return {
                ...state,
                loading: false,
                aimagWater:action.payload.aimags,
                success:action.payload.success
            }

        case actionTypes.getAimag.REQUEST:
            return {
                ...state,
                loading: true,
                aimags: [],
            }
        case actionTypes.getAimag.RESPONSE:
            return {
                ...state,
                loading: false,
                aimags:action.payload.aimags,
                success:action.payload.success
            }
        case actionTypes.getUploadFile.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
            }
        case actionTypes.getUploadFile.RESPONSE:
            return {
                ...state,
                loading: false,
                success:action.payload.success,
                definitions: (state.definitions || []).map(el =>
                    el.id === action.payload.definitionUpdate[0].id 
                        ? action.payload.definitionUpdate[0] 
                        : el
                )
            }

        case actionTypes.getDefinition.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
            }
        case actionTypes.getDefinition.RESPONSE:
            console.log(state.definitions)
            console.log(action.payload.definition)
            return {
                ...state,
                loading: false,
                success:action.payload.success,
                definitions: [...(state.definitions || []), action.payload.definition]
            }

        case actionTypes.getDefinitions.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
            }
        case actionTypes.getDefinitions.RESPONSE:
            return {
                ...state,
                loading: false,
                definitions:action.payload.definitions,
                success:action.payload.success
            }
        case actionTypes.getRequest.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
            }
        case actionTypes.getRequest.RESPONSE:
            let allReq = state.requests
            allReq.push(action.payload.request[0])
            return {
                ...state,
                loading: false,
                success:action.payload.success,
                requests:allReq
            }
//********** */
        case actionTypes.getRequestWater.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
            }
        case actionTypes.getRequestWater.RESPONSE:
            let allReqgetRequestWater = state.requests
            allReqgetRequestWater.push(action.payload.request[0])
            return {
                ...state,
                loading: false,
                success:action.payload.success,
                requests:allReqgetRequestWater
            }
//************* */
        case actionTypes.getRequests.REQUEST:
            return {
                ...state,
                loading: true,
                requests:[],
                success: false,
            }
        case actionTypes.getRequests.RESPONSE:
            return {
                ...state,
                loading: false,
                requests:action.payload.requests,
                success:action.payload.success
            }

    case actionTypes.getOtherRequest.REQUEST:
            return {
                ...state,
                loading: true,
                requests:[],
                success: false,
            }
        case actionTypes.getOtherRequest.RESPONSE:
            return {
                ...state,
                loading: false,
                requests:action.payload.requests,
                success:action.payload.success
            }
        case actionTypes.sendToMail.REQUEST:
            return {
                ...state,
                sending: true,
                success: false,
            }
        case actionTypes.sendToMail.RESPONSE:
            return {
                ...state,
                sending: false,
                success:action.payload.success
            }
        case actionTypes.getSettings.REQUEST:
            return {
                ...state,
                settings: [],
                success: false,
            }
        case actionTypes.getSettings.RESPONSE:
            return {
                ...state,
                settings: action.payload.settings,
                success:action.payload.success
            }
        case actionTypes.updateSettings.REQUEST:
            return {
                ...state,
                success: false,
            }
        case actionTypes.updateSettings.RESPONSE:
            let singleSettings = action.payload.updateSettings[0]
            // allsett.push(action.payload.updateSettings[0])
            return {
                ...state,
                settings: state.settings.map(el=>{
                    if(el.type===singleSettings.type){
                        el.value= singleSettings.value
                        el.created= singleSettings.created
                    }
                    return el
                }),
                success:action.payload.success
            }
        case actionTypes.getDashboardSingle.REQUEST:
            return {
                ...state,
                dashboard_single: [],
                success: false,
            }
        case actionTypes.getDashboardSingle.RESPONSE:
            return {
                ...state,
                dashboard_single: action.payload.dashboard_single[0],
                success: true,
            }
        case actionTypes.getDashboardMulti.REQUEST:
            return {
                ...state,
                dashboard_multi: [],
                success: false,
            }
        case actionTypes.getDashboardMulti.RESPONSE:
            return {
                ...state,
                dashboard_multi: action.payload.dashboard_multi,
                success: true,
            }
        case actionTypes.getConfirmationPage.REQUEST:
            return {
                ...state,
                loading_confirmation:true,
                confirmationPage: [],
                success: false,
            }
        case actionTypes.getConfirmationPage.RESPONSE:
            return {
                ...state,
                loading_confirmation:false,
                confirmationPage: action.payload.confirmationPage,
                success: true,
            }
        default:
            return state;
    }
}